import asyncComponent from '../helpers/AsyncFunc';

const routes = [
  {
    path: 'githubSearch',
    component: asyncComponent(() => import('./containers/GithubSearch'))
  },
  {
    path: 'blank_page',
    component: asyncComponent(() => import('./containers/blankPage'))
  },
  {
    path: 'devices',
    component: asyncComponent(() => import('./containers/Devices/DeviceListContainer'))
  },
  {
    path: 'devices/patient/:id',
    component: asyncComponent(() => import('./containers/Devices/DeviceListContainer'))
  },
  {
    path: 'users',
    component: asyncComponent(() => import('./containers/Users/UserListContainer'))
  },
  {
    path: 'clients',
    component: asyncComponent(() => import('./containers/Clients/ClientListContainer'))
  },
  {
    path: 'questionnaires',
    component: asyncComponent(() => import('./containers/Questionnaire/QuestionnaireList'))
  },
  {
    path: 'questionnaires/create',
    component: asyncComponent(() => import('./containers/Questionnaire/CreateQuestionnaire'))
  },
  {
    path: 'questionnaires/create/:id',
    component: asyncComponent(() => import('./containers/Questionnaire/CreateQuestionnaire'))
  },
  {
    path: 'questionnaires/builder/:id/manage',
    component: asyncComponent(() => import('./containers/Questionnaire/QuestionnaireBuilder'))
  },
  {
    path: 'questionnaires/builder/:id/manage/questions/create',
    component: asyncComponent(() => import('./containers/Questionnaire/QuestionnaireBuilder'))
  },
  {
    path: "karie_users",
    component: asyncComponent(() => import("./containers/KarieUsers"))
  },
  {
    path: "karie_users/:id",
    component: asyncComponent(() => import("./containers/KarieUsers"))
  },
  {
    path: 'support/devices',
    component: asyncComponent(() => import('./containers/Support/Devices/DevicesSupportListContainer'))
  },
  {
    path: 'support/documents',
    component: asyncComponent(() => import('./containers/Support/Documents/DocumentSupportListContainer'))
  },
  {
    path: 'support/monitoring',
    component: asyncComponent(() => import('./containers/Support/PharmacyMonitoring/PharmacyMonitoringContainer'))
  },
  {
    path: 'medication_strips',
    component: asyncComponent(() => import('./containers/MedicationStrips/MedicationStripListContainer'))
  },
  {
    path: 'medication_strips/schedules/:scheduleId',
    component: asyncComponent(() => import('./containers/MedicationStrips/MedicationStripListContainer'))
  },
  {
    path: 'device_events',
    component: asyncComponent(() => import('./containers/DeviceEvents/DeviceEventsContainer'))
  },
  {
    path: 'devices_update',
    component: asyncComponent(() => import('./containers/Update/DevicesUpdateContainer'))
  },
  {
    path: 'customerDevices',
    component: asyncComponent(() => import('./containers/CustomerDevices/CustomerDeviceListContainer'))
  },
  {
    path: 'manufacturing/createDevices',
    component: asyncComponent(() => import('./containers/Manufacturing/CreateDevices/AddUpdateDevicesContainerNew'))
  },
  {
    path: 'manufacturing/deviceInfo',
    component: asyncComponent(() => import('./containers/Manufacturing/DevicesInfo/ManufacturingDevicesInfoContainer'))
  },

];
export default routes;
